import { action, actionNoCatch } from "../common/Action"
import { UsersClient, LoginRequestDto, ResetPasswordRequest } from "../generated";

const loginService = new UsersClient();

class LoginActions {
    @actionNoCatch
    async login(loginDataDto: LoginRequestDto) {
        await loginService.login(loginDataDto);
        return await loginService.get();
    };

    @action
    signOut() {
        return loginService.signOut();
    };

    @action
    getAccountInfo() {
        return loginService.get();
    }

    @action
    setNewsRead() {
        return loginService.setNewsRead();
    }

    @action
    resetPassword(request: ResetPasswordRequest) {
        return loginService.resetPassword(request);
    }
}
export default new LoginActions();